import { Check, Warning, CancelledIcon, Question } from '@ankr.com/ui';
import { ApiWorthStatus } from 'multirpc-sdk';

import { useStatusIconStyles } from './useStatusIconStyles';

interface UseStatusIconProps {
  status?: ApiWorthStatus;
  hasNoData?: boolean;
  size?: number;
  className?: string;
}

export const useStatusIcon = ({
  className,
  hasNoData,
  size = 18,
  status,
}: UseStatusIconProps) => {
  const { classes, cx } = useStatusIconStyles();

  const getStatusClassName = () => {
    if (hasNoData || !status) {
      return cx(classes.iconNoData, className);
    }

    switch (status) {
      case 'operational':
        return cx(classes.iconSuccess, className);
      case 'degraded_performance':
      case 'partial_outage':
        return cx(classes.iconWarning, className);
      case 'major_outage':
        return cx(classes.iconError, className);
      default:
        return cx(classes.iconSuccess, className);
    }
  };

  const iconClassName = getStatusClassName();

  if (hasNoData || !status) {
    return <Question size={size} className={iconClassName} />;
  }

  switch (status) {
    case 'operational':
      return <Check size={size} className={iconClassName} />;
    case 'degraded_performance':
    case 'partial_outage':
      return <Warning size={size} className={iconClassName} />;
    case 'major_outage':
      return <CancelledIcon size={size - 8} className={iconClassName} />;
    default:
      return <Check size={size} className={iconClassName} />;
  }
};
